import { useEnvironment } from '@publicisgroupe/p-os-components/build/contexts/EnvironmentContext';
import React from 'react';
import { useLocation } from 'react-router';
import { ModuleEnum } from '../../utils/enums';
import { MicroModule } from '../MicroModule/MicroModule';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { ModuleUriParams } from 'types/types';
import { useModuleValidation } from './hooks/useModuleValidation';
import { moduleNameToEnum } from 'utils/helpers';
import ErrorPage from 'components/ErrorPage';
import { useTranslation } from 'react-i18next';

export const ModuleContent = (props: RouteComponentProps) => {
  const { history } = props;
  const { settings } = useEnvironment();
  const location = useLocation();
  const isValidModule = useModuleValidation();
  const { t } = useTranslation();
  const { module: moduleNameFromRoute } = useParams<ModuleUriParams>();

  if (!isValidModule(moduleNameFromRoute))
    return <ErrorPage headerText={t('NotFound')} bodyText={t('ErrorMessage')} />;

  const module = moduleNameToEnum(moduleNameFromRoute);

  const url = new URL(`https://pos-${module}-${settings.environment}.titan.international/`);
  url.search = location.search ?? '';

  return (
    <>
      {/* Render all enum key. Each module needs its own microModule instance, otherwise we will get a nasty bug, 
          because the div just changes id, instead of being replaced with another div. Thats why separate if's*/}
      {Object.keys(ModuleEnum).map((modulName) => (
        <React.Fragment key={modulName}>
          <div id={`${modulName}-container`} className={'micro-module'} />
          {module === modulName && <MicroModule history={history} moduleName={modulName} />}
        </React.Fragment>
      ))}
    </>
  );
};
